import { createBreakpoint } from 'styled-components-breakpoint';

const screenSizes = {
  xs: 0,
  sm: 576,
  tablet: 737,
  md: 768,
  lg: 1024,
  xl: 1200,
};

export const breakpoint = createBreakpoint(screenSizes);



// WEBPACK FOOTER //
// ./src/components/Footer/breakpoints.js